export const WEB_ORDER_TYPE = "web"
